import React from 'react';

// Intro cloud overlay markup (SVG turbulence filters + 4 blob divs).
// Shared between the live map (PeopleMap) and the /clouds preview page so the
// look stays in sync. `phase` is one of: 'covered' | 'parting' | 'gone'.
export function MapClouds({ phase = 'covered' }) {
  return (
    <div className={`people-map__clouds people-map__clouds--${phase}`} aria-hidden="true">
      <svg className="people-map__cloud-defs" width="0" height="0">
        <filter id="pm-cloud-1" x="-40%" y="-40%" width="180%" height="180%" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="8" result="blur" />
          <feTurbulence type="fractalNoise" baseFrequency="0.011" numOctaves="4" seed="7" result="noise" />
          <feDisplacementMap in="blur" in2="noise" scale="100" xChannelSelector="R" yChannelSelector="G" />
        </filter>
        <filter id="pm-cloud-2" x="-40%" y="-40%" width="180%" height="180%" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
          <feTurbulence type="fractalNoise" baseFrequency="0.009 0.013" numOctaves="5" seed="24" result="noise" />
          <feDisplacementMap in="blur" in2="noise" scale="125" xChannelSelector="R" yChannelSelector="G" />
        </filter>
        <filter id="pm-cloud-3" x="-40%" y="-40%" width="180%" height="180%" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="7" result="blur" />
          <feTurbulence type="fractalNoise" baseFrequency="0.015" numOctaves="4" seed="41" result="noise" />
          <feDisplacementMap in="blur" in2="noise" scale="80" xChannelSelector="R" yChannelSelector="G" />
        </filter>
        <filter id="pm-cloud-4" x="-40%" y="-40%" width="180%" height="180%" colorInterpolationFilters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="9" result="blur" />
          <feTurbulence type="fractalNoise" baseFrequency="0.012 0.009" numOctaves="5" seed="63" result="noise" />
          <feDisplacementMap in="blur" in2="noise" scale="115" xChannelSelector="R" yChannelSelector="G" />
        </filter>
      </svg>
      <div className="people-map__cloud people-map__cloud--1" />
      <div className="people-map__cloud people-map__cloud--2" />
      <div className="people-map__cloud people-map__cloud--3" />
      <div className="people-map__cloud people-map__cloud--4" />
    </div>
  );
}

export default MapClouds;
